import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";

interface StateInterface {
  requests: {};
  requestsOutdated: boolean;
  count: string;
  countUnpaid: string;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  requests: {},
  requestsOutdated: false,
  count: "",
  countUnpaid: "",
  fields: [],
  translatedMessage: ""
};

export const chargesReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CHARGES_SAVE_LIST_SUCCESS:
    {
      const request: string = action.payload?.request;
      let requests = !!state.requests ? {...state.requests} : {};
      const count: number =!!action.payload?.count ? action.payload?.count : 0;
      const charges: ChargeInterface[] = !!action.payload?.charges ? action.payload?.charges : [];

      requests[request] = {
        count: count,
        charges: [...charges]
      };

      return {
        ...state,
        requests: {...requests},
        requestsOutdated: false
      };
    }

    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
      return {...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };

    case Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS:
    {
      return {
        ...initialState,
        count: state.count,
        countUnpaid: state.countUnpaid,
        requestsOutdated: true
      };
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
